module.exports = __webpack_public_path__ + "img/picture_as_pdf.8bcccd1f.svg";